import { set } from 'lodash';

//* For purpose cached somethings and use outside components
class CacheService {
  constructor() {
    this.userInfo = {};
    this.optOutdomainsSupporting = [];
    this.shortLinkConditions = [];
    this.backgroundProcessEnum = {};
    this.serviceVendors = {};
    this.vendors = [];
    this.appConfigs = {};
  }

  set(key, value) {
    set(this, key, value);
  }
}

export default new CacheService();
